import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PRODUCT_NAME = "İstasyon Platformu";
/** Ürün adını gösteren başlık; iskelet aşamasında paketler arası bağlantıyı doğrular. */
export function BrandTitle({ subtitle }) {
    return (_jsxs("header", { children: [_jsx("h1", { children: PRODUCT_NAME }), subtitle ? _jsx("p", { children: subtitle }) : null] }));
}
//# sourceMappingURL=brand.js.map